import { useState } from 'react';
import ReactPaginate from 'react-paginate';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import {
  Typography,
  Button,
  Grid,
  useMediaQuery,
} from '@material-ui/core';
import { PaginationProps } from './types';
import DropdownMenu from '../DropdownMenu';
import useStyles from './styles';

const amounts = [10, 30, 50];

const Pagination = (
  props: PaginationProps,
) => {
  const {
    total,
    variant,
    onChangePage,
    onChangeCount,
    anchorOrigin,
    transformOrigin,
  } = props;

  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);

  const classes = useStyles();

  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));

  const getFromTo = (
    v: number,
  ) => ({
    from: (v - 1) * limit + 1,
    to: v * limit,
  });

  const handleOnCountChange = (
    amount: number,
  ) => {
    setLimit(amount);
    const selectedPage = page;
    const newPageCount = Math.ceil(total / amount);
    if (selectedPage > newPageCount) {
      setPage(newPageCount);
    }
    onChangeCount({
      limit: amount,
      page: newPageCount,
    });
  };

  const handleOnPageChange = ({ selected }: {
    selected: number
  }) => {
    const v = selected + 1;
    setPage(v);
    onChangePage({
      limit,
      page: v,
    });
  };

  const renderMenuItem = (
    amount: number,
  ) => (
    <Grid container>
      <Grid item>
        {`Show ${amount}`}
      </Grid>
    </Grid>
  );

  const renderCounts = () => {
    const { from, to } = getFromTo(page);
    const labelCounts = `${from} - ${to > total ? total : to} of ${total}`;
    if (variant === 'simple') {
      return (
        <Typography variant="body2">
          {labelCounts}
        </Typography>
      );
    }

    const options = amounts.map((v) => ({
      name: v,
      children: renderMenuItem(v),
      onClick: () => handleOnCountChange(v),
    }));
    return (
      <DropdownMenu
        options={options}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
      >
        {({ open }) => (
          <Button onClick={open} className={classes.pageAmountButton}>
            <Typography variant="body2">
              {labelCounts}
            </Typography>
          </Button>
        )}
      </DropdownMenu>
    );
  };

  return (
    <>
      {
        total ? (
          <Grid
            container
            alignItems="center"
            justifyContent={variant === 'simple' ? 'space-between' : 'flex-start'}
          >
            <Grid
              item
              container
              xs={variant === 'simple' ? 4 : 12}
              sm={2}
              justifyContent={!isMobile || variant === 'simple' ? 'flex-start' : 'center'}
            >
              { renderCounts() }
            </Grid>
            <Grid item className={classes.pages} xs={variant === 'simple' ? 8 : 12} sm={10}>
              <ReactPaginate
                forcePage={page - 1}
                pageRangeDisplayed={!isMobile ? 2 : 1}
                marginPagesDisplayed={!isMobile ? 3 : 2}
                pageCount={Math.ceil(total / limit)}
                onPageChange={handleOnPageChange}
                containerClassName={`
                  ${classes.container}
                  ${variant === 'simple' ? classes.hideNumbers : ''}
                `}
                pageLinkClassName={classes.link}
                previousLinkClassName={classes.link}
                nextLinkClassName={classes.link}
                breakLinkClassName={classes.breakLink}
                disabledClassName={`${classes.disabledLink} ${variant === 'simple' ? classes.hideAll : ''}`}
                activeLinkClassName={classes.activeLink}
                previousLabel={<ChevronLeftIcon />}
                nextLabel={<ChevronRightIcon />}
              />
            </Grid>
          </Grid>
        ) : null
      }
    </>
  );
};

Pagination.defaultProps = {
  anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
  transformOrigin: { vertical: 'top', horizontal: 'right' },
  variant: 'detailed',
};

export default Pagination;
